import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Trash2 } from "lucide-react";
import { supabase } from "../../../lib/supabase";
import { deleteFromFtp } from "../../../lib/deleteFromFtp";

interface ImageItem {
  id: string;
  url: string;
  title?: string;
  description?: string;
}

const GalleryList: React.FC = () => {
  const [images, setImages] = useState<ImageItem[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchGallery = async () => {
    const { data, error } = await supabase.from('gallery').select('*');
    if (error) {
        console.error(error);
    } else {
        setImages(data as ImageItem[]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchGallery();
  }, []);

  const handleDelete = async (id: string) => {
      if(!window.confirm("Bu resmi silmek istediğinize emin misiniz?")) return;
      
      const itemToDelete = images.find(img => img.id === id);

      try {
          const { error } = await supabase.from('gallery').delete().eq('id', id);
          if (!error) {
              if (itemToDelete?.url) deleteFromFtp(itemToDelete.url);
              fetchGallery();
          } else {
              console.error(error);
          }
      } catch (error) {
          console.error(error);
      }
  }

  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row justify-between items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Galeri Yönetimi</h1>
          <p className="text-gray-500">Tüm resimleri görüntüleyin ve düzenleyin</p>
        </div>
        <Link
          to="/panel/gallery/add"
          className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg flex items-center shadow-sm transition-all"
        >
          <Plus className="w-5 h-5 mr-2" />
          Yeni Resim Ekle
        </Link>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden p-6">
        {loading ? (
          <div className="text-center text-gray-500">Yükleniyor...</div>
        ) : images.length === 0 ? (
          <div className="text-center text-gray-500">Resim bulunamadı.</div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {images.map((item) => (
              <div key={item.id} className="relative group rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow">
                <div className="aspect-square">
                  <img 
                    src={item.url} 
                    alt={item.title || "Gallery"} 
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="absolute inset-x-0 bottom-0 flex justify-between items-center bg-black/60 text-white text-xs p-2 translate-y-full group-hover:translate-y-0 transition-transform">
                  <p className="truncate font-medium flex-1">{item.title || "Başlıksız"}</p>
                  <button onClick={() => handleDelete(item.id)} className="bg-red-500 rounded-full p-1 ml-2 text-white hover:bg-red-600 transition-colors">
                      <Trash2 size={14} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default GalleryList;
